// removed by extract-text-webpack-plugin
module.exports = {"divider":"divider__1vr270HYZzSW"};